import { PendingDispersionStatus } from '../data/useGetPendingDispersions';

export type PendingDispersionsSearchFormValues = {
  status: PendingDispersionStatus | '';
};

export const EMPTY_FILTERS: PendingDispersionsSearchFormValues = {
  status: '',
};
